import { WSSidebar } from "@wingspanhq/fe-component-library";
import { Payout, PayoutTransferPurpose } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import {
  RouteComponentProps,
  useHistory,
  useLocation,
  useRouteMatch
} from "react-router-dom";

import { queriesPayouts } from "@query";
import { getParentPath } from "../../../../utils/goToParentRoute";
import { WSQueries } from "../../../../query/WSQuery";
import { PayoutAccountDetailsItem } from "./PayoutAccountDetailsItem";

export const PayoutAccountDetails: React.FC<
  RouteComponentProps<{
    customFieldId: string;
  }>
> = () => {
  const history = useHistory();
  const location = useLocation<{ backPath: string }>();
  const backPath = location.state?.backPath || getParentPath(history);
  const match = useRouteMatch<{ payoutId: string }>();

  const queryPayout = queriesPayouts.getPayout.useQuery({
    payoutId: match.params.payoutId
  });

  const onBack = () => {
    if (backPath) {
      history.push({
        pathname: backPath,
        search: location.search,
        state: {
          ...(location.state ?? {})
        }
      });
    }
  };

  return (
    <WSSidebar.Container onClose={onBack}>
      <WSQueries queries={{ queryPayout }}>
        {({ queryPayoutData }) => (
          <WSSidebar.Layout header={"Payout accounts details"}>
            <Inner data={queryPayoutData} onBack={onBack} />
          </WSSidebar.Layout>
        )}
      </WSQueries>
    </WSSidebar.Container>
  );
};

export const Inner: React.FC<{
  data: Payout;
  onBack: () => void;
}> = props => {
  const data = props.data;

  const disbursementTransfers = data.transfers.filter(
    transfer => transfer.purpose === PayoutTransferPurpose.DISBURSEMENT
  );
  const walletTransfer = data.transfers.find(
    transfer => transfer.purpose === PayoutTransferPurpose.WALLET_REMAINDER
  );

  return (
    <>
      {disbursementTransfers.map(payoutAccountItem => (
        <PayoutAccountDetailsItem
          key={payoutAccountItem.id}
          payoutAccountItem={payoutAccountItem}
          payout={data}
        />
      ))}
      {walletTransfer && (
        <PayoutAccountDetailsItem
          payoutAccountItem={walletTransfer}
          payout={data}
          isWallet={true}
        />
      )}
    </>
  );
};
